import React from 'react';
import moment from 'moment';
import '../sass/print_credit_request.sass';

export default function PrintCreditRequest(props) {
  const { 
    state
  } = props;

  return (
      <div className="print">
        <span className="print__title">Заявление на получение микрокредита</span>
        <div className="print-item">
          <div className="print-desc">
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Ф.И.О. заявителя</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientLastname} {state.clientFirstname} {state.clientPatronymic}</div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Дата рождения</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{moment(state.clientDateOfBirth).format('DD.MM.YYYY')} г.</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">ИИН</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientIIN}</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Гражданство</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientCitizenship}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Вид на жительство </span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Образование</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientEducationLevel}</div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Паспорт/уд. личн. №</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientDocumentNumber}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">выдан</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientDocumentIssuerName}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <div className="print-desc-item__text">{moment(state.clientDocumentIssueDate).format('DD.MM.YYYY')} г.</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Семейное положение</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientMaritalStatusName}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Ф.И.О. супруга(и) </span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientSpouseInfo}</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Количество взрослых в семье</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '4px' }}>{state.clientDependentsNumber || 0}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Количество детей до 18 лет</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '4px'  }}>{state.clientChildCount || 0}</div>
              </div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Адрес фактического проживания:</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientActualAddress}</div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Телефон дом </span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientHomePhoneNumber}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон раб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientWorkPhoneNumber}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон моб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.clientMobilePhoneNumber}</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Даю согласие получать SMS/ WhatsApp на:</span>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Казахском языке:</span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Русском языке:</span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">На получение информации на  WhatsApp  тел. Моб.</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}></div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Адрес электронной почты Заявителя:</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}></div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Основной источник дохода:</span>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">з/плата</span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">от бизнеса</span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">прочий</span>
                <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
              </div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Адрес бизнеса/места работы:</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.employerAddress}</div>
            </div>
          </div>
          <div className="print-item">
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Контактное лицо (ФИО, кем приходится заемщику)</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.contact1Name}</div>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.contact1RelationshipName}</div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Адрес контактного лица</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}></div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Телефон дом </span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон раб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон моб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}>{state.contact1PhoneNumber}</div>
              </div>
            </div>
            <div className="print-desc-item flex-column">
              <span className="print-desc-item__notion">Подтверждаю, что сведения об указанных контактных лицах предоставлены с их ведома и согласия.</span>
            </div>
          </div>
          <div className="print-item">
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Контактное лицо (ФИО, кем приходится заемщику)</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.contact2Name}</div>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.contact2RelationshipName}</div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Адрес контактного лица</span>
              <div className="print-desc-item__text" style={{ marginLeft: '6px' }}></div>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Телефон дом </span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон раб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}></div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Телефон моб</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px', minWidth: '60px' }}>{state.contact2PhoneNumber}</div>
              </div>
            </div>
            <div className="print-desc-item flex-column">
              <span className="print-desc-item__notion">Подтверждаю, что сведения об указанных контактных лицах предоставлены с их ведома и согласия.</span>
            </div>
          </div>
          <div className="print-item">
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Запрашиваемая сумма</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.creditAmount} тенге</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Срок</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.creditTerm} мес.</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Льготный период</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}> мес.</div>
              </div>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Целевое назначение кредита
                <span className="print-desc-item__notion" style={{ marginLeft: '6px', borderBottom: '1px solid black' }}>Приобретение автотранспорта</span>
              </span>
            </div>
            <div className="print-desc-item flex-row">
              <span className="print-desc-item__title">Имущество, предоставляемое в обеспечение исполнения заявителем обязательств по погашению микрокредита и выплате вознаграждения
                <span className="print-desc-item__notion" style={{ marginLeft: '6px', borderBottom: '1px solid black' }}>{state.creditObjectName}</span>
              </span>
            </div>
            <div className="flex-row">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Марка и Модель ТС</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.carBrand} {state.carModel}</div>
              </div>
              <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                <span className="print-desc-item__title">Стоимость обеспечения</span>
                <div className="print-desc-item__text" style={{ marginLeft: '6px' }}>{state.totalPrice} тенге</div>
              </div>
            </div>
          </div>
          <div className="print-item">
            <span className="print-desc-item__notion" style={{ textAlign: 'left' }}>Согласен, что принятие к рассмотрению МФО «KMF»  данной  Заявки не означает возникновения у «KMF» обязательства по предоставлению займа</span>
            <div className="flex-column box">
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Привлекались ли когда-либо к уголовной ответственности, в том числе за действия, связанные с легализацией (отмыванием) доходов, полученных преступным путем, или финансированием терроризма либо с иной преступной деятельностью? 
                  <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                    <span className="print-desc-item__title">ДА</span>
                    <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                    <span className="print-desc-item__title" style={{ marginLeft: '6px' }}>НЕТ</span>
                    <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                  </div>
                </span>
              </div>
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Являетесь ли Вы и/или Ваш супруг (супруга), и/или близкие родственники публичными должностными лицами?  
                  <div className="print-desc-item flex-row" style={{ marginLeft: '6px' }}>
                    <span className="print-desc-item__title">ДА</span>
                    <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                    <span className="print-desc-item__title" style={{ marginLeft: '6px' }}>НЕТ</span>
                    <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                  </div>
                </span>
              </div>
              <div className="print-desc-item flex-row">
                <span className="print-desc-item__title">Подтверждаю, что я проинформирован ТОО «МФО «KMF (КМФ)», о правах и обязанностях, связанных с получением микрокредита
                  <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                </span>
              </div>
              <div className="print-desc-item flex-row" style={{ marginTop: '4px' }}>
                <span className="print-desc-item__title">Подтверждаю, что я ознакомился с проектами графиков погашения микрокредита, рассчитанных методами дифференцированных, аннуитетных платежей и другим методом. Также подтверждаю, что выбранный мной метод погашения микрокредита будет указан в договоре о предоставлении микрокредита в соответствии с приложением к договору Графиком погашения микрокредита.   
                  <div className="print-desc-item__checkbox" style={{ marginLeft: '6px' }}></div>
                </span>
              </div>
            </div>
          </div>
          <div className="print-item">
            <span className="print-desc-item__notion"><b>Перечень мероприятий, осуществлённых ТОО «МФО «KMF (КМФ)» до заключения договора о предоставлении микрокредита с Заявителем, указанным в данном Заявлении на получение микрокредита:</b></span>
            <div className="print-desc-item__points" style={{ marginTop: '6px' }}>
              Заявителю были предоставлены для ознакомления и выбора метода погашения микрокредита проекты графиков погашения, рассчитанных в соответствии с требованиями законодательства и правилами предоставления микрокредитов ТОО «МФО «KMF (КМФ)».
            </div>
            <div className="print-desc-item__points">
            Заявитель проинформирован о своих правах и обязанностях, связанных с получением микрокредита.
            </div>
          </div>
          <div className="print-item">
            <span className="print-desc-item__title">Место подписи Клиента:</span> 
            <div className="flex-row">
              <div className="box" style={{ minWidth: '180px' }}>
                Подпись
              </div>
              <div className="box" style={{ minWidth: '180px' }}>
                Дата:
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};